(function () {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var searchDrawerHydrated = false;

    function refreshLazyImages() {
        if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
        }
    }

    function hydrateTemplate(template) {
        if (!template || !template.content) return;
        template.replaceWith(template.content.cloneNode(true));
    }

    function hydrateSearchDrawer() {
        if (searchDrawerHydrated) return;
        searchDrawerHydrated = true;

        document.querySelectorAll('template[data-olitans-defer-search-drawer]').forEach(hydrateTemplate);
        refreshLazyImages();
        document.dispatchEvent(new CustomEvent('olitans:search-drawer-hydrated'));
    }

    function isSearchIntent(target) {
        if (!target || !target.closest) return false;

        return Boolean(target.closest([
            'predictive-search',
            '.header__search',
            '.header__search-full',
            '.search_details',
            '.search-modal__form',
            '.search__input',
            'input[type="search"]',
            '[data-search-mobile]',
            '[data-search-menu]',
            '[data-search-sticky-form]',
            '[data-search-menu-sticky-form]',
            '[data-search-popup]',
            '#search-form-mobile'
        ].join(',')));
    }

    function onSearchIntent(event) {
        if (!isSearchIntent(event.target)) return;
        hydrateSearchDrawer();
    }

    document.addEventListener('pointerdown', onSearchIntent, true);
    document.addEventListener('focusin', onSearchIntent, true);
    document.addEventListener('keydown', onSearchIntent, true);
})();
